import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { environment } from '../environments/environment';

const connectionString = environment.APPLICATION_INSIGHTS?.CONNECTION_STRING;

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: connectionString,
    enableAutoRouteTracking: true,
    samplingPercentage: environment.APPLICATION_INSIGHTS.SAMPLING_PERCENTAGE,
    enableUnhandledPromiseRejectionTracking: true,
  },
});

export declare const enum eSeverityLevel {
  Verbose = 0,
  Information = 1,
  Warning = 2
}

if (connectionString) {
  appInsights.loadAppInsights();
  appInsights.trackPageView();
  patchConsole(appInsights);
}

function patchConsole(ai: ApplicationInsights) {
  const origLog = console.log.bind(console);
  const origInfo = console.info.bind(console);
  const origWarn = console.warn.bind(console);
  const origError = console.error.bind(console);

  console.log = (...args: any[]) => {
    safeTrace(ai, "console.log", args, eSeverityLevel.Verbose);
    origLog(...args);
  };

  console.warn = (...args: any[]) => {
    safeTrace(ai, "console.warn", args, eSeverityLevel.Warning);
    origWarn(...args);
  };

  console.info = (...args: any[]) => {
    safeTrace(ai, "console.info", args, eSeverityLevel.Information);
    origInfo(...args);
  };

  console.error = (...args: any[]) => {
    safeException(ai, "console.error", args);
    origError(...args);
  };
}

function safeTrace(ai: ApplicationInsights, tag: string, args: any[], severityLevel?: number) {
  try {
    ai.trackTrace({
      message: `${tag}: ${argsToString(args)}`,
      severityLevel,
      properties: {
        tag,
      },
    });
  } catch {
    // never break the app because of telemetry
  }
}

function safeException(ai: ApplicationInsights, tag: string, args: any[]) {
  try {
    ai.trackException({
      exception: new Error(`${tag}: ${argsToString(args)}`),
      properties: { tag },
    });
  } catch {
    // ignore
  }
}

function argsToString(args: any[]) {
  return args
    .map((a) => {
      if (typeof a === "string") return a;
      try {
        return JSON.stringify(a);
      } catch {
        return String(a);
      }
    })
    .join(" ");
}
